/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Form, Button } from "react-bootstrap";

const RegisterDateBlock = (props) => {
  const toRecord = props.toRecord;
  const recordid = props.recordid;
  const type = props.type;
  // Manage visibility without needing to fetch all the data again.
  const [unusableState, setUnusableState] = useState(props.registerResult.unusable);
  const [attended, setAttended] = useState(props.registerResult.attended);

  const handleAttendance = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    let attendedState;
    if (attended) {
      attendedState = false;
    } else {
      attendedState = true;
    }
    const registerAttendRequest = await axios.put(
      `/api/admin/registers/attend/${type}`,
      {
        toRecord,
        recordid,
        attendedState,
      },
      {
        withCredentials: true,
      }
    );
    if (registerAttendRequest.status === 200) {
      setAttended(attendedState);
      return props.setSubmitClicked(false);
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with that request.");
    }
  };

  const handleUnusable = async (e) => {
    e.preventDefault();
    let newState;
    if (unusableState) {
      newState = false;
    } else {
      newState = true;
    }
    props.setSubmitClicked(true);
    const registerUsableRequest = await axios.put(
      `/api/admin/registers/usable/${type}`,
      {
        toRecord,
        recordid,
        newState,
      },
      {
        withCredentials: true,
      }
    );
    if (registerUsableRequest.status === 200) {
      setUnusableState(newState);
      return props.setSubmitClicked(false);
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with that request.");
    }
  };

  return (
    <td td className='align-self-center align-middle'>
      <Form>
        <span>
          {!unusableState && (
            <Form.Check
              className='mb-1'
              checked={attended}
              type='checkbox'
              onClick={(e) => handleAttendance(e)}
              disabled={props.submitClicked}
            />
          )}
          <Button
            variant='secondary'
            size='sm'
            type='submit'
            onClick={(e) => handleUnusable(e)}
            disabled={props.submitClicked}
          >
            {!unusableState && <span>&#9986;</span>}
            {unusableState && <span>&#10010;</span>}
          </Button>
        </span>
      </Form>
    </td>
  );
};

export default RegisterDateBlock;
